import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
var _excluded = ["children", "transition"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import * as styles from "../styles/PageSlider.styles";
export var PAGE_SLIDER_PAGE_CLASS_NAME = 'pageslider__page';
export var PageSlider = function PageSlider(_ref) {
  var _props$pageIndex;
  var children = _ref.children,
    transition = _ref.transition,
    props = _objectWithoutProperties(_ref, _excluded);
  var pageIndex = (_props$pageIndex = props.pageIndex) !== null && _props$pageIndex !== void 0 ? _props$pageIndex : 0;
  var pages = React.Children.count(children);
  var pagesWidth = "".concat(pages * 100, "%");
  var pagesTranslateX = "-".concat(pageIndex * (100 / pages), "%");
  var pageWidth = "".concat(100 / pages, "%");
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: styles.pagesWrapper
  }, /*#__PURE__*/React.createElement(_StyledDiv2, {
    "data-testid": "pageslider__pages",
    style: {
      width: pagesWidth,
      '--translateX': pagesTranslateX,
      transition: transition
    },
    $_css2: styles.pages
  }, React.Children.map(children, function (child, index) {
    return /*#__PURE__*/React.createElement("div", {
      "aria-hidden": index !== pageIndex,
      className: PAGE_SLIDER_PAGE_CLASS_NAME,
      "data-testid": "pageslider__page",
      style: {
        width: pageWidth
      }
    }, child);
  })));
};
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledDiv2 = /*#__PURE__*/_styled2("div").withConfig({
  displayName: "PageSlider___StyledDiv2",
  componentId: "sc-1x8kw7t-0"
})(["", ""], function (p) {
  return p.$_css2;
});